import { Box, Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { TRANSLATION_KEY } from '../constants';

const RequestScalePlanSuccess = ({ imageSrc, title, description, onClose, renderAction }) => {
  const { t } = useTranslation(TRANSLATION_KEY);

  return (
    <Box
      display="flex"
      flexDirection={{ xs: 'column', sm: 'row' }}
      padding="32px"
      overflow="hidden"
      gap="28px"
    >
      <Box flex={1} display="flex" flexDirection="column" gap="16px">
        <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
          <Box
            component="img"
            src={imageSrc}
            alt={title}
            sx={{
              width: '100%',
              objectFit: 'contain',
              borderRadius: '12px',
            }}
          />
        </Box>

        <Typography variant="h5" fontWeight={700} color="accent.900">
          {title}
        </Typography>

        <Box>
          <Typography variant="body2" color="accent.500">
            {description}
          </Typography>
        </Box>

        {renderAction && renderAction()}

        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={onClose}
          sx={{ borderRadius: '24px', textTransform: 'none', mt: '18px' }}
        >
          {t('CLOSE')}
        </Button>
      </Box>

      <Box
        sx={{
          display: { xs: 'none', sm: 'flex' },
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          component="img"
          src={imageSrc}
          alt={title}
          sx={{
            objectFit: 'contain',
            borderRadius: '12px',
          }}
        />
      </Box>
    </Box>
  );
};

export default RequestScalePlanSuccess;
